import { render, staticRenderFns } from "./ViewAccount.vue?vue&type=template&id=e965d948&scoped=true&"
import script from "./ViewAccount.vue?vue&type=script&lang=js&"
export * from "./ViewAccount.vue?vue&type=script&lang=js&"
import style0 from "./ViewAccount.vue?vue&type=style&index=0&id=e965d948&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e965d948",
  null
  
)

export default component.exports